/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiResponse, CompoApiService, IssueCheckList} from 'compob2b-libs';
import {map} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class IssueChecklistService {

  constructor(private readonly apiService: CompoApiService) {
  }

  load(id: number): Observable<IssueCheckList[]> {
    const url = '/issue/' + id + '/checklist';

    return this.apiService.get<IssueCheckList[]>(url).pipe(
      map(response => response.data.sort((a, b) => {
        if (a.checked != b.checked) {
          return a.checked > b.checked ? -1 : 1;
        }
        return a.id > b.id ? 1 : -1;
      }))
    );
  }

  store(payload: IssueCheckList): Observable<IssueCheckList> {
    const url = '/issue/checklist';
    return this.apiService.post<IssueCheckList, IssueCheckList>(url, payload).pipe(
      map((response: ApiResponse<IssueCheckList>) => response.data)
    );
  }

  update(payload: IssueCheckList): Observable<IssueCheckList> {
    const url = '/issue/checklist';
    return this.apiService.patch<IssueCheckList, IssueCheckList>(url, payload).pipe(
      map((response: ApiResponse<IssueCheckList>) => response.data)
    );
  }
}
